
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","viewBox":"-1 -1 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.206 12.265l9.28-9.273a1.749 1.749 0 000-2.478 1.749 1.749 0 00-2.478 0l-9.273 9.28 2.47 2.47z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.736 9.794L0 14.001l4.206-1.736-2.47-2.47z","fill":"#fff"}}),_c('path',{attrs:{"d":"M1.735 9.794l2.47 2.47-2.47-2.47z","fill":"#fff"}}),_c('path',{staticClass:"cl-1",attrs:{"d":"M1.735 9.794l2.47 2.47","stroke":"#000","stroke-miterlimit":"10","stroke-linejoin":"round"}})])
          )
        }
      }
    